import React, { useMemo } from "react";
import { detectLevel, getMsg } from "../utils";

import LogsKpis from "./components/LogsKpis";
import LogsControls from "./components/LogsControls";
import LogsTable from "./components/LogsTable";
import LogDetailsPanel from "./components/LogDetailsPanel";

// ⚠️ ACHTUNG: Pfad prüfen!
// wenn dein File hier liegt:
// src/pages/monitoring/logs/utils/filterRows.js
import { filterRows } from "./utils/search";

export default function LogsView({
  styles,
  services,
  servicesLoading,
  service,
  setService,
  minutes,
  setMinutes,
  limit,
  setLimit,
  query,
  setQuery,
  rows,
  logsLoading,
  logsErr,
  selected,
  setSelected,
}) {
  // 🔹 1) Gefilterte Rows (einzige Source of Truth)
  const filteredRows = useMemo(() => {
    if (!Array.isArray(rows) || rows.length === 0) return [];
    return filterRows(rows, query);
  }, [rows, query]);

  // 🔹 2) KPIs immer aus filteredRows berechnen
  const stats = useMemo(() => {
    let errors = 0;
    let warns = 0;
    let infos = 0;

    for (const r of filteredRows) {
      const lvl = detectLevel(getMsg(r));
      if (lvl === "FATAL" || lvl === "ERROR") errors++;
      else if (lvl === "WARN") warns++;
      else infos++;
    }

    return {
      total: filteredRows.length,
      errors,
      warns,
      infos,
    };
  }, [filteredRows]);

  return (
    <>
      {/* KPI BAR */}
      <LogsKpis
        styles={styles}
        stats={stats}
        minutes={minutes}
        limit={limit}
      />

      {/* FILTER / CONTROLS */}
      <LogsControls
        styles={styles}
        services={services}
        servicesLoading={servicesLoading}
        service={service}
        setService={setService}
        minutes={minutes}
        setMinutes={setMinutes}
        limit={limit}
        setLimit={setLimit}
        query={query}
        setQuery={setQuery}
        setSelected={setSelected}
      />

      {/* ERROR */}
      {logsErr && <div style={styles.errorBox}>{logsErr}</div>}

      {/* TABLE + DETAILS */}
      <div style={styles.split}>
        <LogsTable
          styles={styles}
          rows={filteredRows}
          logsLoading={logsLoading}
          selected={selected}
          setSelected={setSelected}
        />

        <LogDetailsPanel
          styles={styles}
          selected={selected}
          setSelected={setSelected}
        />
      </div>
    </>
  );
}
